import {TStepQuestions} from "../../types/TStepQuestions";
import {ReactComponentElement, ReactNode, useCallback, useEffect, useState} from "react";
import ProjectContactForm from "./ProjectContactForm";
import Alert from "../content/Alert";

export function ProjectCostResult({values, formImage}: { values: TStepQuestions, formImage: ReactNode }) {
    const [calculatedPrice, setCalculatedPrice] = useState(0);
    const [defaultMessage, setDefaultMessage] = useState('');


    // Format currency to USD
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    const calculateCosts = () => {
        let basePrice = 0;
        let baseFactor = 1;

        // Project Type
        const projectType = values.find((question) => question.name === 'projectType')?.value;

        switch (projectType) {
            case 'Web':
                basePrice = 10000;
                baseFactor = .7;
                break;
            case 'Mobile':
                basePrice = 15000;
                baseFactor = 1.1;
                break;
            case 'Desktop':
                basePrice = 18000;
                baseFactor = 1.4;
                break;
        }

        // Features
        const features = values.find((question) => question.name === 'features')?.value as Array<string>;

        const featurePrices = {
            'User Authentication': 5000,
            'Social Media Integration': 6000,
            'Push Notifications': 4000,
            'Chat': 6000,
            'Search Functionality': 6000,
            'File Uploads': 2500,
            'Maps': 2000,
            'Video Streaming': 8000,
            'E-Commerce': 10000,
            'Real-Time Data': 10000,
            'Email Sending': 2000,
            'Data Processing': 4500,
            'Data Entry': 5000,
            'Messaging Functionality': 4500,
        };

        for (let item of Object.entries(featurePrices)) {
            if (features.includes(item[0])) {
                basePrice += item[1];
            }
        }

        // Multilingual
        const multilingual = values.find((question) => question.name === 'multilingual')?.value;
        if (multilingual === 'Yes') {
            basePrice += 7000;
        }

        // Payment Processing
        const paymentProcessing = values.find((question) => question.name === 'paymentProvider')?.value;
        if (paymentProcessing === 'Yes') {
            basePrice += 10000;
        }

        // Design
        const design = values.find((question) => question.name === 'design')?.value;
        switch (design) {
            case 'Simple':
                basePrice += 5000;
                break;
            case 'Intricate':
                basePrice += 10000;
                baseFactor += 0.2;
                break;
        }

        // Project Timeline
        const timeline = values.find((question) => question.name === 'projectTimeline')?.value;

        switch (timeline) {
            case '< 3 Months':
                baseFactor += 0.4;
                break;
            case '3 - 6 Months':
                baseFactor += 0.2;
                break;
            case '6 - 9 Months':
                baseFactor += 0.1;
                break;
        }

        let msg = 'Hello, I would like to get in touch with you to discuss my project: \n\n';
        values.map((question) => {
            let value = question.value;
            if(Array.isArray(value)) {
                value = (question.value as Array<String>).join(', ');
            }

            msg += `${question.label}: ${value} \n`
        });
        setDefaultMessage(msg)

        setCalculatedPrice(basePrice)
    }

    useEffect(() => {
        calculateCosts();
    }, [values]);



    return <div className={' py-16 sm:py-12'}>
        <h1>Project Cost Result</h1>

        <Alert>
            Please keep in mind:
            Development Project Costs can depend on a variety of factors, so that it&apos;s impossible to give you
            an exact
            figure.
            <br/>
            However, we can give you an approximate figure based on the information you&apos;ve provided:
        </Alert>

        <div className={'grid grid-cols-7 w-full text-center mt-12 text-xs'}>
            <div className={'col-span-1 '}>

            </div>

            <div className={'col-span-1 '}>
                low end
            </div>
            <div className={'col-span-3'}>
                most likely range
            </div>
            <div className={'col-span-1 '}>
                higher end
            </div>

            <div className={'col-span-1 py-3'}>

            </div>
        </div>

        <div className={'grid grid-cols-7 w-full text-center mb-12 bg-gray-100 rounded-xl'}>
            <div className={'col-span-1 py-3'}>
                <span className={'hidden md:inline'}>
                $0
                </span>
            </div>

            <div className={'col-span-1 py-3 bg-lime-200'}>
                <span className={'hidden md:inline'}>
                {formatter.format(Math.round(calculatedPrice * .6))}
                    </span>
            </div>
            <div className={'col-span-3 py-3 bg-lime-700 border-l border-r border-black text-white'}>
                {formatter.format(Math.round(calculatedPrice * .8))} - {formatter.format(Math.round(calculatedPrice * 1.2))}
            </div>
            <div className={'col-span-1 py-3 bg-lime-200'}>
                <span className={'hidden md:inline'}>
                {formatter.format(Math.round(calculatedPrice * 1.4))}
                </span>
            </div>

            <div className={'col-span-1 py-3'}>
                <span className={'hidden md:inline'}>
                $250,000
                </span>
            </div>
        </div>


        <ProjectContactForm defaultMessage={defaultMessage} formImage={formImage}/>
    </div>

}